import React, { useState, useRef } from "react";
import { convertToHtml } from "mammoth";
import { Spinner, RainbowThemeContainer } from "react-rainbow-components";
import { CustomModal } from "./../../revampComponents/Atom/Modals";

const UploadDoc = ({ editor, onChange, theme }) => {
	const [fileUploading, setFileUploading] = useState(false);
	const uploadRef = useRef(null);

	const uploadDoc = e => {
		e.preventDefault();
		uploadRef.current.click();
	};

	const convertToHTML = async e => {
		try {
			e.preventDefault();
			const files = e.target.files || [];
			if (!files.length) return;
			const file = files[0];
			const reader = new FileReader();
			reader.onloadend = () => {
				const arrayBuffer = reader.result;
				setFileUploading(true);
				convertToHtml({ arrayBuffer: arrayBuffer })
					.then(resultObject => {
						uploadRef.current.value = null;
						editor.commands.setContent(resultObject.value);
						onChange(resultObject.value);
						setFileUploading(false);
					})
					.catch(err => {
						setFileUploading(false);
						throw new Error(err);
					});
			};
			reader.readAsArrayBuffer(file);
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<>
			{fileUploading && (
				<CustomModal
					openModal={fileUploading}
					setOpenModal={state => setFileUploading(state)}
					header={null}
					noClose={true}
					content={
						<>
							<div className="spinner d-flex justify-content-center align-items-center p-5">
								<RainbowThemeContainer theme={theme}>
									<Spinner size="large" type="arc" variant="brand" />
								</RainbowThemeContainer>
							</div>
						</>
					}
				/>
			)}
			<div className="upload-doc-prompt">
				<a href="#" onClick={uploadDoc}>
					Have a word document? Click here to upload.
				</a>
				<input type="file" ref={uploadRef} onChange={convertToHTML} className="d-none" />
			</div>
		</>
	);
};

export default UploadDoc;
